export const SENDOSO_ROLE_IS_NOT_VALID_FOR_REGISTER = 'sendoso_role_is_not_valid_for_register';
export const SENDOSO_SYSTEM_USER_NOT_REGISTERED = 'SENDOSO_SYSTEM_USER_NOT_REGISTERED';
export const SENDOSO_USER_TOKEN_NOT_FOUND = 'SENDOSO_USER_TOKEN_NOT_FOUND';
export const INVALID_ORDER_VERSION_ERROR = 'INVALID_ORDER_VERSION_ERROR';
export const POSTAL_USER_TOKEN_NOT_FOUND = 'POSTAL_USER_TOKEN_NOT_FOUND';
export const POSTAL_USER_TOKEN_NOT_VALID = 'POSTAL_USER_TOKEN_NOT_VALID';
export const POSTAL_SERVER_ERROR = 'POSTAL_SERVER_ERROR';
export const UPS_ACCESS_TOKEN_NOT_FOUND = 'UPS_ACCESS_TOKEN_NOT_FOUND';
export const DHL_ACCESS_TOKEN_NOT_FOUND = 'DHL_ACCESS_TOKEN_NOT_FOUND';
export const CONFIRM_ACTION_EXPIRED = 'CONFIRM_ACTION_EXPIRED';
export const CONFIRM_ACTION_USED = 'CONFIRM_ACTION_USED';
export const CONFIRM_ACTION_DOESNT_EXIST = 'CONFIRM_ACTION_DOESNT_EXIST';
export const PASSWORD_NOT_SET = 'PASSWORD_NOT_SET';
export const EBADCSRFTOKEN = 'EBADCSRFTOKEN';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const GIVEAWAY_SUBMISSION_PRODUCTS_INVALID = 'GIVEAWAY_SUBMISSION_PRODUCTS_INVALID';
export const GIVEAWAY_SUBMISSION_NO_LONGER_AVAILABLE = 'GIVEAWAY_SUBMISSION_NO_LONGER_AVAILABLE';
export const GIVEAWAY_SUBMISSION_PRODUCTS_AMOUNT_INVALID = 'GIVEAWAY_SUBMISSION_PRODUCTS_AMOUNT_INVALID';
export const GOODIE_GIVEAWAY_BUDGET_EXCEED = 'GOODIE_GIVEAWAY_BUDGET_EXCEED';
export const GOODIE_GIVEAWAY_BUDGET_INVALID = 'GOODIE_GIVEAWAY_BUDGET_INVALID';
export const GOODIE_GIVEAWAY_NO_INTERNATIONAL_SHIPPING = 'GOODIE_GIVEAWAY_NO_INTERNATIONAL_SHIPPING';
export const BUNDLE_HAS_CUSTOM_PACKAGING_IN_STOCK_OR_IN_PRODUCTION = 'BUNDLE_HAS_CUSTOM_PACKAGING_IN_STOCK_OR_IN_PRODUCTION';
export const BUNDLE_HAS_ADVANCED_DISTRIBUTION = 'BUNDLE_HAS_ADVANCED_DISTRIBUTION';
export const SENDOSO_SHIP_NOTICE_IS_UNAVAILABLE = 'SENDOSO_SHIP_NOTICE_IS_UNAVAILABLE';
export const SERVICE_EXECUTION_ABORTED = 'SERVICE_EXECUTION_ABORTED';
export const FORBIDDEN = 'Forbidden';
export const PRE_BUILD_REGULAR_CART_ALREADY_PLACED = 'PRE_BUILD_REGULAR_CART_ALREADY_PLACED';
export const PRE_BUILD_LIMITED_CART_ALREADY_PLACED = 'PRE_BUILD_LIMITED_CART_ALREADY_PLACED';
export let CartErrorCodes = /*#__PURE__*/function (CartErrorCodes) {
  CartErrorCodes[CartErrorCodes["INVALID_ORDER_TOKEN"] = 102] = "INVALID_ORDER_TOKEN";
  CartErrorCodes[CartErrorCodes["INVALID_ORDER_ITEM_ID"] = 103] = "INVALID_ORDER_ITEM_ID";
  CartErrorCodes[CartErrorCodes["INVALID_DRAFT_TOKEN"] = 104] = "INVALID_DRAFT_TOKEN";
  CartErrorCodes[CartErrorCodes["INVALID_ORDER_VERSION"] = 105] = "INVALID_ORDER_VERSION";
  CartErrorCodes[CartErrorCodes["SUPER_SPEED_DISABLED"] = 106] = "SUPER_SPEED_DISABLED";
  return CartErrorCodes;
}({});
export let InvitationCodes = /*#__PURE__*/function (InvitationCodes) {
  InvitationCodes[InvitationCodes["INVITATION_IS_NOT_VALID"] = 107] = "INVITATION_IS_NOT_VALID";
  InvitationCodes[InvitationCodes["INVITATION_EMAIL_DIDNT_MATCH_USER_EMAIL"] = 108] = "INVITATION_EMAIL_DIDNT_MATCH_USER_EMAIL";
  InvitationCodes[InvitationCodes["INVITATION_ALREADY_ACCEPTED"] = 109] = "INVITATION_ALREADY_ACCEPTED";
  InvitationCodes[InvitationCodes["INVITATION_REJECTED"] = 110] = "INVITATION_REJECTED";
  InvitationCodes[InvitationCodes["INVITATION_CORRECT"] = 111] = "INVITATION_CORRECT";
  return InvitationCodes;
}({});
export const FORBIDDEN_ERROR_CODE = 403;